import { UserProfile, UserProfileRestricted } from 'components/userProfile';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableCustomer.module.scss';

/** Represents the content of the customer cell in the conversations table. */
export const ConversationsTableCustomer = (): JSX.Element => {
  const {
    conversationAndRequester: { conversation, requester },
    isRestricted,
  } = useConversationRow();
  const description = conversation.is_abandoned
    ? 'Abandoned'
    : conversation.attributes.subject;

  return isRestricted ? (
    <UserProfileRestricted />
  ) : (
    <UserProfile
      user={requester}
      truncateName
      description={description}
      descriptionClassName={styles.description}
    />
  );
};
